"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OauthAuthMissingInSpec = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "OauthAuthMissingInSpec";
const messageKey = "driver.oauth.error.oauthAuthMissingInSpec";
class OauthAuthMissingInSpec extends teamsfx_api_1.UserError {
    constructor(actionName, authName) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, authName),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, authName),
        });
    }
}
exports.OauthAuthMissingInSpec = OauthAuthMissingInSpec;
//# sourceMappingURL=oauthAuthMissingInSpec.js.map